import { Box, Container, Grid, Typography } from '@mui/material';
import NativeSelect from '@mui/material/NativeSelect';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Button from '@mui/material/Button';
import { MOTORS, MOTORS_RATED_RPM } from '../App';

const MotorSelector = ({ isImportedPoints, onChnage }) => {
    return (
        <Box>
            <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                <InputLabel variant="standard" htmlFor="uncontrolled-native">
                    Motor
                </InputLabel>
                <NativeSelect
                    disabled={isImportedPoints}
                    onChange={onChnage}
                    defaultValue={MOTORS[0]}
                    inputProps={{
                        name: 'motor',
                        id: 'uncontrolled-native',
                    }}
                >
                    {MOTORS.map((value, index) => {
                        return (<option key={index} value={MOTORS_RATED_RPM[index]}>{value}</option>)
                    })
                    }
                </NativeSelect>
            </FormControl>
        </Box>

    )
}

export default MotorSelector;
